import * as React from 'react'

import s from 'styled-components'

const Hide = s.div`
  display: ${(props: { display?: string, hidden?: boolean }) => {
    if (props.hidden) {
      return 'none'
    }

    return props.display || 'block'
  }}
`

interface HideProps {
  children: any
  hidden: boolean
  display: string
}

export default ({ children, hidden, ...rest }: HideProps) => (
  <Hide hidden={hidden} {...rest}>
    {children}
  </Hide>
)



// WEBPACK FOOTER //
// ./src/components/atoms/Hide.tsx